import axios from 'axios'
const request=axios.create({
    baseURL:"https://m-blog.onrender.com/api"
})
export default request
